import type { GameId } from '@tg/shared';

/**
 * Games whose route is still a "coming soon" stub (`GameSoon` from pages/ComingSoon in routes.tsx). Nothing may send a
 * player there as if the game were playable — e.g. the admin form of table tournaments does not offer them, the lobby
 * shows «soon». A game leaves this list in the same commit that gives it a real page (Dou Dizhu left it in 7б-3).
 */
export const SOON_GAMES: ReadonlySet<GameId> = new Set<GameId>([]);

export const hasGamePage = (game: GameId): boolean => !SOON_GAMES.has(game);
